import { render, staticRenderFns } from "./printSmallPayFeeList.vue?vue&type=template&id=490f13ff&scoped=true"
import script from "./printSmallPayFeeList.vue?vue&type=script&lang=js"
export * from "./printSmallPayFeeList.vue?vue&type=script&lang=js"
import style0 from "./printSmallPayFeeList.vue?vue&type=style&index=0&id=490f13ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f13ff",
  null
  
)

export default component.exports